import { useState } from 'react'
import { Send, Phone, Mail } from 'lucide-react'

export function FigmaFooterSection() {
  const [lookingFor, setLookingFor] = useState('')
  const [itemName, setItemName] = useState('')
  const [phone, setPhone] = useState('')
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    alert('Sourcing request submitted successfully!')
  }

  return (
    <div className="space-y-12 py-8 relative">
      {/* ========================================================================= */}
      {/* 1. CAN'T FIND YOUR PART OR VEHICLE? (DARK DUAL FORM CARD) */}
      {/* ========================================================================= */}
      <section className="mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-[28px] bg-[#10141e] border border-white/10 shadow-2xl p-6 sm:p-10 text-white">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
            
            {/* Left Image Box */}
            <div className="lg:col-span-5 relative overflow-hidden rounded-2xl h-[280px] sm:h-[340px]">
              <img
                src="https://images.unsplash.com/photo-1503376780353-7e6692767b70?q=90&w=800&auto=format&fit=crop"
                alt="Custom Sourcing"
                className="h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
            </div>

            {/* Right Sourcing Form */}
            <div className="lg:col-span-7 space-y-5">
              <div className="text-center space-y-1">
                <div className="flex justify-center mb-1">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#CF2F2F]/20 text-[#CF2F2F] border border-[#CF2F2F]/30 text-base font-bold">
                    ?
                  </span>
                </div>
                <h3 className="font-display text-xl sm:text-2xl font-extrabold uppercase tracking-tight">
                  CAN'T FIND YOUR PART OR VEHICLE?
                </h3>
                <p className="text-xs text-gray-400">
                  Submit a sourcing enquiry and our global dealer network will trace the exact component for you.
                </p>
              </div>

              <form onSubmit={handleSubmit} className="space-y-3.5">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3.5">
                  <div className="space-y-1">
                    <label className="text-[10px] font-bold text-gray-400 uppercase block">I AM LOOKING FOR A:</label>
                    <input
                      type="text"
                      placeholder="Performance Spare Part / Kit"
                      value={lookingFor}
                      onChange={(e) => setLookingFor(e.target.value)}
                      className="w-full h-10 rounded-xl bg-white/5 border border-white/10 px-3.5 text-xs text-white placeholder:text-gray-500 focus:outline-none focus:border-[#CF2F2F]"
                    />
                  </div>

                  <div className="space-y-1">
                    <label className="text-[10px] font-bold text-gray-400 uppercase block">ITEM NAME / MODEL:</label>
                    <input
                      type="text"
                      placeholder="e.g. Porsche 911 GT3 Carbon Hood"
                      value={itemName}
                      onChange={(e) => setItemName(e.target.value)}
                      className="w-full h-10 rounded-xl bg-white/5 border border-white/10 px-3.5 text-xs text-white placeholder:text-gray-500 focus:outline-none focus:border-[#CF2F2F]"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3.5">
                  <div className="space-y-1">
                    <label className="text-[10px] font-bold text-gray-400 uppercase block">PHONE*</label>
                    <div className="relative">
                      <Phone className="absolute left-3 top-3 h-3.5 w-3.5 text-gray-500 pointer-events-none" />
                      <input
                        type="text"
                        placeholder="+91 98765 43210"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        className="w-full h-10 rounded-xl bg-white/5 border border-white/10 pl-9 pr-3.5 text-xs text-white placeholder:text-gray-500 focus:outline-none focus:border-[#CF2F2F]"
                      />
                    </div>
                  </div>

                  <div className="space-y-1">
                    <label className="text-[10px] font-bold text-gray-400 uppercase block">EMAIL (OPTIONAL)</label>
                    <div className="relative">
                      <Mail className="absolute left-3 top-3 h-3.5 w-3.5 text-gray-500 pointer-events-none" />
                      <input
                        type="email"
                        placeholder="yourname@example.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="w-full h-10 rounded-xl bg-white/5 border border-white/10 pl-9 pr-3.5 text-xs text-white placeholder:text-gray-500 focus:outline-none focus:border-[#CF2F2F]"
                      />
                    </div>
                  </div>
                </div>

                <div className="space-y-1">
                  <label className="text-[10px] font-bold text-gray-400 uppercase block">REQUIREMENTS / MESSAGE:</label>
                  <textarea
                    rows={2}
                    placeholder="Year, engine model, part numbers, chassis type..."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    className="w-full rounded-xl bg-white/5 border border-white/10 p-3 text-xs text-white placeholder:text-gray-500 focus:outline-none focus:border-[#CF2F2F]"
                  />
                </div>

                <div className="flex justify-center pt-1">
                  <button
                    type="submit"
                    style={{ backgroundColor: '#CF2F2F' }}
                    className="inline-flex items-center gap-2 px-8 py-3 rounded-xl text-xs font-extrabold text-white uppercase tracking-wider shadow-lg hover:opacity-90 transition-all active:scale-95"
                  >
                    <Send className="h-3.5 w-3.5" />
                    <span>SUBMIT SOURCING REQUEST</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* ========================================================================= */}
      {/* 2. PROMOTIONAL TIRE DISCOUNT BANNER */}
      {/* ========================================================================= */}
      <section className="mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-8">
        <div
          className="relative overflow-hidden rounded-2xl p-6 sm:p-8 text-white flex flex-col sm:flex-row items-center justify-between gap-6 shadow-xl"
          style={{ backgroundColor: '#B82323' }}
        >
          <div className="space-y-1 text-center sm:text-left">
            <span className="text-[10px] font-bold tracking-widest text-white/80 uppercase block">LIMITED OFFER</span>
            <h3 className="font-display text-xl sm:text-3xl font-extrabold tracking-tight uppercase">
              TAKE CARE OF YOUR TIRE 22% OFF
            </h3>
            <p className="text-[11px] text-white/70">
              This discount is not valid in conjunction with other active offers.
            </p>
          </div>

          <div className="flex items-center gap-4 shrink-0">
            <div className="hidden md:block h-16 w-32 rounded-lg overflow-hidden border border-white/20">
              <img
                src="https://images.unsplash.com/photo-1542282088-72c9c27ed0cd?q=80&w=400&auto=format&fit=crop"
                alt="Tire Offer"
                className="h-full w-full object-cover"
              />
            </div>
            <button
              type="button"
              className="px-6 py-3 rounded-xl bg-black text-white text-xs font-bold uppercase tracking-wider hover:bg-gray-900 transition-all shadow-md active:scale-95"
            >
              CLAIM DISCOUNT
            </button>
          </div>
        </div>
      </section>
    </div>
  )
}
